import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuongtiengiaothongduongbo from "components/Phuongtiengiaothong/Phuongtiengiaothongduongbo.js";
export default function DmPhuongtien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo phương tiện giao thông đường bộ tháng",
            tabContent: <Phuongtiengiaothongduongbo />,
          },
        ]}
      />
    </div>
  );
}
